import { useMemo } from "react";

const EMPTY = [];

// Lines this user is assigned to (source of truth: machines.operator_ids).
export const linesForUser = (machines, userId) => machines.filter((m) => (m.operator_ids || []).includes(userId));

// Operators see only the lines they are assigned to and the jobs running on them (UI-only filter).
// Planners/admins get everything back untouched (`scoped: false`).
export function useOperatorScope(user, machines = EMPTY, orders = EMPTY, downtimes = EMPTY, gatePasses = EMPTY) {
  return useMemo(() => {
    if (user.role !== "operator") return { scoped: false, assigned: true, machines, orders, downtimes, gatePasses };
    const mine = linesForUser(machines, user.id);
    const lineIds = new Set(mine.map((m) => m.id));
    const myOrders = orders.filter((o) => o.line_id && lineIds.has(o.line_id));
    const orderIds = new Set(myOrders.map((o) => o.id));
    return {
      scoped: true,
      assigned: mine.length > 0,
      machines: mine,
      orders: myOrders,
      downtimes: downtimes.filter((d) => lineIds.has(d.machine_id)),
      gatePasses: gatePasses.filter((g) => orderIds.has(g.order_id)),
    };
  }, [user.role, user.id, machines, orders, downtimes, gatePasses]);
}
